module.exports = __webpack_public_path__ + "img/image-7.0d6f1a05.jpg";